import { PersonType, Currency } from 'enums';

export enum BankAccountOwnership {
  'CLIENT' = 'CLIENT',
  'JOINED' = 'JOINED',
  'OTHER' = 'OTHER',
  'NONE' = '',
}

export interface BankDataOptions {
  ownerFirstname: string;
  ownerLastname: string;
  ownerCompanyName: string;
  ownership: string[];
  code: string[];
  czCodes: string[];
  skCodes: string[];
}

export interface BankData {
  addingEnabled: boolean;
  bankAccounts: BankAccount[];
  options: BankDataOptions;
  personType?: PersonType;
  currency: Currency;
}

export interface BankAccount {
  knownToOcp?: boolean;
  primary?: boolean;
  verified?: boolean;
  id?: string;
  title: string;
  bank: string;
  bankCode: string;
  accountNumber: string;
  accountPrefix: string;
  fullNumber: string;
  hasIban: boolean;
  iban: string;
  ownership?: string;
  ownerFirstname: string;
  ownerLastname: string;
  ownerCompanyName: string;
  currency: Currency;
}

export const initialValues: BankAccount = {
  knownToOcp: false, // Default value for optional field
  primary: false, // Default value for optional field
  verified: false, // Default value for optional field
  id: '', // Default value for optional field
  title: '',
  bank: '',
  bankCode: '',
  accountNumber: '',
  accountPrefix: '',
  fullNumber: '',
  hasIban: false,
  iban: '',
  ownership: BankAccountOwnership.NONE,
  ownerFirstname: '',
  ownerLastname: '',
  ownerCompanyName: '',
  currency: Currency.NONE,
};
